export const reminderResourceType = [
    {
        title: "Event",
        value: "Modules\\EventManagement\\Entities\\Event",
        permission: "event-management.event",
    },
    {
        title: "Meeting",
        value: "Modules\\EventManagement\\Entities\\Meeting",
        permission: "event-management.meeting",
    },
    {
        title: "Hosting",
        value: "Modules\\Hosting\\Entities\\Hosting",
        permission: "hosting.hostings",
    },
    {
        title: "Server",
        value: "Modules\\Hosting\\Entities\\Server",
        permission: "hosting.servers",
    },
    {
        title: "Schedule Job",
        value: "Modules\\Recruitment\\Entities\\JobPostCandidateSchdule",
        permission: "recruitment.schedule-jobs",
    },
    {
        title: "Follow UP",
        value: "App\\Models\\FollowUp",
        permission: "quote-manager.followups",
    },
];
export const modelName = {
    event: "Modules\\EventManagement\\Entities\\Event",
    meeting: "Modules\\EventManagement\\Entities\\Meeting",
    hosting: "Modules\\Hosting\\Entities\\Hosting",
    server: "Modules\\Hosting\\Entities\\Server",
    schedule_job: "Modules\\Recruitment\\Entities\\JobPostCandidateSchdule",
    follow_up: "App\\Models\\FollowUp",
};
export const query = { perPage: "all" };

export const selectRecodeVal = (data, type) => {
    if (modelName.event === type) {
        return {
            id: data.id,
            title: data.title,
            date: data.start_date,
            time: data.start_time,
            dateTime: `${data.start_date} ${data.start_time}`,
        };
    } else if (modelName.meeting === type) {
        return {
            id: data.id,
            title: data.title,
            date: data.date,
            time: data.time,
            dateTime: `${data.start_date} ${data.start_time}`,
        };
    } else if (modelName.hosting === type) {
        return {
            id: data.id,
            title: data.title,
            date: data.formated_start_date,
            time: data.time ?? "00:00",
            dateTime: `${data.formated_start_date} ${
                data.start_time ?? "00:00"
            }`,
        };
    } else if (modelName.server === type) {
        return {
            id: data.id,
            title: data.name,
            date: data.formated_purchase_date,
            time: data.time ?? "00:00",
            dateTime: `${data.formated_purchase_date} ${
                data.start_time ?? "00:00"
            }`,
        };
    } else if (modelName.schedule_job === type) {
        return {
            id: data.id,
            title: data.name,
            date: data.formated_purchase_date,
            time: data.time ?? "00:00",
            dateTime: `${data.formated_purchase_date} ${
                data.start_time ?? "00:00"
            }`,
        };
    } else if (modelName.follow_up === type) {
        return {
            id: data.id,
            title: data.name,
            date: data.formated_purchase_date,
            time: data.time ?? "00:00",
            dateTime: `${data.formated_purchase_date} ${
                data.start_time ?? "00:00"
            }`,
        };
    }
     else {
        return data;
    }
};

export const setListData = (value) => {
    let url = null;
    let title = null;
    let id = "id";
    let queryData = {};
    const now = new Date();
    const system_timezone = window.APP.system_timezone;
    const options = { timeZone: system_timezone, hour12: false };
    const dateInIST = new Date(now.toLocaleString("en-US", options));
    const currentDate = dateInIST.toISOString().split("T")[0];
    const currentTime = dateInIST.toTimeString().slice(0, 5);

    switch (value) {
        case modelName.meeting:
            url = route("event-management.meetings.index");
            queryData = {
                ...query,
                start_date: currentDate,
                start_time: currentTime,
            };
            title = "title";
            break;

        case modelName.event:
            url = route("event-management.events.index");
            queryData = {
                ...query,
                startDate: currentDate,
                startTime: currentTime,
            };
            title = "title";
            break;
        case modelName.hosting:
            url = route("hosting.hostings.index");
            queryData = {
                ...query,
                fromDate: currentDate,
                startTime: currentTime,
            };
            title = "hosting_plan";
            break;
        case modelName.server:
            url = route("hosting.servers.index");
            queryData = {
                ...query,
                purchase_date: currentDate,
                startTime: currentTime,
            };
            title = "name";
            break;
        case modelName.schedule_job:
            url = route("recruitment.scheduled.candidates");
            queryData = {
                ...query,
                schedule_date: currentDate,
                schedule_time: currentTime,
            };
            title = "candidate_name";
            id = "schedule_id";
            break;
          case modelName.follow_up:
            url = route("hrm.employee.followups");
            queryData = {
                ...query,
                followUpDate: currentDate,
                allData: true
            };
            title = "component_name";
            id = "id";
            break;
    }

    return [url, title, queryData, id];
};
